<template>
    <div id="associate-site-to-asset-widget-component">
        <widget-wrapper-component :title="$t('associate_assets_to_site')" icon="mdi-storage-tank-outline">
            <template v-slot:default>
                <div class="mb-8">
                    <h3>{{ domicile.address_name }} - {{ displayHumanSiteAddress(domicile) }}</h3>
                    <h4>
                        <p v-html="$t('x_assets_on_site', [assets.length])" />
                    </h4>
                </div>
                <template v-for="(asset, indexAsset) in assets" class="mt-3">
                    <div :key="indexAsset" class="pa-2 mb-6 rounded site-border" >
                        <div style="position: relative; bottom: 25px">
                            <v-chip class="pa-2 site-border-asset" style="background-color: white">
                                {{ $t('return_devices.asset') }}
                                {{ indexAsset }}
                            </v-chip>
                        </div>
                        <v-row class="flex-wrap">
                            <v-col>
                                <div class="image-container">
                                    <template v-if="asset.images.length !== 0">
                                        <v-carousel :show-arrows="asset.images.length > 1" height="350">
                                            <template v-slot:prev="{ on, attrs }">
                                                <v-btn color="validation-button" fab small v-bind="attrs" v-on="on">
                                                    <v-icon color="white">mdi-chevron-left</v-icon>
                                                </v-btn>
                                            </template>

                                            <template v-slot:next="{ on, attrs }">
                                                <v-btn color="validation-button" fab small v-bind="attrs" v-on="on">
                                                    <v-icon color="white">mdi-chevron-right</v-icon>
                                                </v-btn>
                                            </template>

                                            <v-carousel-item v-for="image in asset.images" :key="image" :src="image" contain />
                                        </v-carousel>

                                    </template>
                                    <template v-else>
                                        <v-img src="../../assets/images/no_image_available.jpg" max-height="200" max-width="250" />
                                    </template>
                                </div>
                                <div class="font-weight-bold ml-2"><v-icon>mdi-storage-tank-outline</v-icon> - {{ asset.name }} {{ asset.asset_liquid ? ' - ' + asset.asset_liquid.name : '' }}</div>
                                <template v-for="(device, indexDevice) in asset.devices" class="mt-3">
                                    <div class="d-flex align-center gap-1 flex-wrap mb-4 mt-4 ml-4" :key="indexDevice">
                                        <img :src="device.path_image_device_referentiel" height="38" />
                                        <div class="ml-2">{{ device.device_number }}</div>
                                        <chips-last-statement
                                            :danger="345600"
                                            :date="device.date_last_emission"
                                            :warning="172800"
                                            class="ml-2"
                                        />
                                        <v-icon class="pointer ml-2" @click="$emit('update:device', device.device_number)"
                                            >mdi-pencil
                                        </v-icon>
                                    </div>
                                </template>
                            </v-col>
                            <v-col>
                                <map-coordinate-component :coordinate="{ latitude: asset.latitude, longitude: asset.longitude }" readonly />
                                <div class="flex">
                                    <v-icon>mdi-map-marker-radius-outline</v-icon>
                                    {{ asset.latitude ? asset.latitude + ' - ' + asset.longitude : $t('no_coordinate') }}
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </template>
            </template>
        </widget-wrapper-component>
    </div>
</template>

<script>
import MenuActionsComponent from '@/components/MenuActionsComponent.vue'
import WidgetWrapperComponent from '@/components/WidgetWrapperComponent.vue'
import DomicileRepository from '@/repositories/DomicileRepository'
import ChipsLastStatement from '@/components/ChipsLastStatement.vue'
import MapCoordinateComponent from '@/components/site/MapCoordinateComponent.vue'

export default {
    name: 'associate-assets-to-site-component',
    components: {
        MapCoordinateComponent,
        ChipsLastStatement,
        MenuActionsComponent,
        WidgetWrapperComponent,
    },
    props: {
        domicile: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            assets: [],
        }
    },
    methods: {
        getAssetsBySite() {
            this.loading = true
            DomicileRepository.getAssetsByDomicile(this.domicile.id_domicile)
                .then((success) => {
                    this.assets = success.data.data
                })
                .catch((error) => {
                    this.manageError(error)
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
    mounted() {
        this.getAssetsBySite()
    },
}
</script>

<style scoped></style>
